module.exports = __webpack_public_path__ + "img/logo_big.785a6d6c.png";